module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/nudge/box-nudge-665972b09bb9c928c04d81603427152c.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/nudge/box-nudge.svg
// module id = SxUp
// module chunks = 24